


























import {
    PosRoutes, PosWaypointType, PosWaypoint, PosSourceType, PosGeocode, PosWaypointConfig,
} from 'gl-ms-positions';
import positions, { waypointType } from '@/services/positions';
import { i18n } from '../../main';

export default {
    data(this: any): any {
        return {
            fixed: '',
            value: '',
            debounceTime: 300,
            hasError: false,
            hover: false,
        };
    },

    props: {
        waypoint: {
            type: Object,
            default: () => ({
                source: PosSourceType.WEB,
                type: PosWaypointType.DOCUMENTS,
                geometry: {
                    coordinates: [0, 0],
                },
                placeholder: true,
            }),
        },
        draggable: {
            type: Boolean,
            default: false,
        },
        fromDispo: {
            type: Boolean,
            default: false,
        },
        onlyAutoComplete: {
            type: Boolean,
            default: false,
        },
        triggerOnFocus: {
            type: Boolean,
            default: false,
        },
        forceDisabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        waypointTypes(this: any) {
            return this.fromDispo ? this.addable : this.addableAll;
        },

        disabled(this: any) {
            return this.waypoint.source !== PosSourceType.WEB || this.waypoint.type === PosWaypointType.DRAG;
        },

        deletable(this: any) {
            return this.waypoint.source === PosSourceType.WEB;
        },

        sortable(this: any) {
            return this.draggable && ((Boolean(this.sortableConfig.includes(this.waypoint.type)) && this.waypoint.source === PosSourceType.WEB) || !this.fromDispo);
        },
        addableAll(this: any) {
            return Object.keys(this.$store.getters.waypointsConfig);
        },
        addable(this: any) {
            const res: string[] = [];

            Object.keys(this.$store.getters.waypointsConfig).forEach((key: string) => {
                const item = this.$store.getters.waypointsConfig[key];
                if (item.includeInPlanningUserSelection) {
                    res.push(key);
                }
            });

            return res;
        },
        sortableConfig(this: any) {
            const res: string[] = [];

            Object.keys(this.$store.getters.waypointsConfig).forEach((key: string) => {
                const item = this.$store.getters.waypointsConfig[key];
                if (item.includeInPlanningSortable) {
                    res.push(key);
                }
            });

            return res;
        },
    },

    methods: {
        async getGeocodeResults(qs: string, cb: Function) {
            if (qs.length < 1) {
                return cb([{ value: i18n.t('common.noDataFound') }]);
            }

            const results = await positions.autocomplete(qs);
            if (results.length < 1) {
                return cb([{ value: i18n.t('common.noDataFound') }]);
            }

            const options = results.map((result: string) => ({
                value: result,
                data: result,
            }));

            return cb(options);
        },

        async onAutocompleteSelect(this: any, item: any) {
            const geocode: PosGeocode[] = await positions.geocode(item.data);
            if (geocode.length) {
                this.waypoint.geometry.coordinates = [geocode[0].Longitude, geocode[0].Latitude];
                this.waypoint.data = geocode[0];
                delete this.waypoint.placeholder;
                return this.$emit('selected', this.waypoint);
            }

            this.hasError = true;
            return [];
        },

        onTypeChange(this: any) {
            this.$emit('updated', this.waypoint);
        },

        deleteItem(this: any) {
            this.$emit('delete', this.waypoint);
        },
    },
};
